import { render } from "./ReturnlyLogoIcon.vue?vue&type=template&id=3769b91e"
import script from "./ReturnlyLogoIcon.vue?vue&type=script&lang=js"
export * from "./ReturnlyLogoIcon.vue?vue&type=script&lang=js"

import "./ReturnlyLogoIcon.vue?vue&type=style&index=0&id=3769b91e&lang=scss"

import exportComponent from "/home/runner/work/flydata-next/flydata-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__